module.exports = __webpack_public_path__ + "static/media/account_login_v2.6912839f.jpg";